
import AddToCartError from './AddToCartError.vue';
import focus from 'JS/directives/focus';
import UiButton from 'JS/components/UiButton.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'MaxLineItemsSidebar',
	components: {
		AddToCartError,
		UiButton,
	},
	directives: {
		'focus': focus,
	}
})
export default class MaxLineItemsSidebar extends Vue {

	/* Props
	============================================*/
	@Prop({ type: String, required: false, default: "You have the maximum number of unique items in your cart. You may split up your purchase across multiple orders. Please proceed to checkout." })
	readonly errorMessage: string;

}
	
